






























































import * as _ from 'lodash';
import { editFactory } from '@/main/pages';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openList } from '@/main/router/routerPath';
import { Doklad } from '@/modules/servis/doklad';
import { formatDateTime } from '@/main/utils/dateFormatter';
import { showAlert } from '@/main/utils/notifications';
import { NAME as ZakazkaName, ZAKAZKA_DRUH_LOCALIZED, ZAKAZKA_ZAPUJCKA } from '@/modules/servis/zakazka/constants';
import { EventBus } from '@/main/eventBus';
import { HlaseniOSkode } from '@/modules/pujcovna/zapujcka/hlaseniOSkode';

import StavPredPujcenim from './components/StavPredPujcenim.vue';
import StavPoVraceni from './components/StavPoVraceni.vue';
import Poznamka from './components/Poznamka.vue';
import InformaceProZapujceni from './components/InformaceProZapujceni.vue';
import EditHeader from './components/EditHeader.vue';
import { apiProvider } from './api';
import { DEPENDENT_TABLES, NAME, ZAPUJCKA_STAV, MILISEKUNDY_DEN, INTERVAL, NAJEMNI_SMLOUVA_TYP } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		EditHeader,
		InformaceProZapujceni,
		StavPredPujcenim,
		StavPoVraceni,
		Poznamka,
	},
	data() {
		return {
			dependencies: DEPENDENT_TABLES,
			showRozsirDialog: false,
			showZakazkaExist: false,
		};
	},
	computed: {
		prehledDokladuFilter() {
			return {
				PujcovnapaId: this.entityId,
			};
		},
		skodyNaPujccePolozkyFilter() {
			return {
				OstatnipaId: this.OstatnipaId,
				VozidlopaId: this.VozidlopaId,
				FakturaceDatOd: this.FakturaceDatOd,
				FakturaceDatDo: this.FaktpristDat,
			};
		},
		localizedStav() {
			return this.LocalizePopisostatni(`rgFlag${this.PujcpaStatus}`);
		},
		showStavPoVraceniTab(): boolean {
			return this.PujcpaStatus !== ZAPUJCKA_STAV.OTEVRENE;
		},
		tabItems(): object {
			return {
				InformaceProZapujceni: { id: 'InformaceProZapujceni', labelKey: 'PujcovnapaTab0' },
				StavPredPujcenim: { id: 'StavPredPujcenim', labelKey: 'PujcovnapaTab3' },
				...(this.showStavPoVraceniTab && { StavPoVraceni: { id: 'StavPoVraceni', labelKey: 'PujcovnapaTab2' } }),
				Poznamka: { id: 'Poznamka', labelKey: 'PujcovnapaTab1' },
				SkodyNaPujcce: { id: 'SkodyNaPujcce', labelKey: 'PujcovnapaTab4' },
				PrehledDokladu: { id: 'PrehledDokladu', labelKey: 'btnPrehledDokladu' },
			};
		},
		zapujckaStav(): Record<string, boolean> {
			return {
				isOtevrena: this.PujcpaStatus === ZAPUJCKA_STAV.OTEVRENE,
				isPujcena: this.PujcpaStatus === ZAPUJCKA_STAV.PUJCENE,
				isVracena: this.PujcpaStatus === ZAPUJCKA_STAV.VRACENE,
				isKFakturaci: this.PujcpaStatus === ZAPUJCKA_STAV.ODEPSANE,
				isFakturovana: this.PujcpaStatus === ZAPUJCKA_STAV.FAKTUROVANE,
				isDlouhodoba: this.PujcpaStatus === ZAPUJCKA_STAV.DLPUJCKA,
			};
		},
	},
	watch: {
		PujcpaStatus(status) {
			if (status !== ZAPUJCKA_STAV.OTEVRENE) {
				EventBus.$emit('DisableAll', true);
			}
			if (this.PujcovnapaNr !== null && this.PujcovnapaNr !== -1) {
				this.titleDetail = `${this.PujcovnapaNr} - ${this.localizedStav}`;
			} else if (this.isCreateMode && this.$route.params.planpujcpaId) {
				this.titleDetail = `${this.localizedStav} - ${this.$route.params.planpujcpaId}`;
			} else {
				this.titleDetail = this.localizedStav;
			}
		},
		PlanovanaZapujckaExists() {
			if (this.PlanovanaZapujckaExists) {
				this.existPlanovanaPujcka();
			}
		},
		CheckResult(result) {
			switch (result) {
				case 'NotExists':
					this.showRozsirDialog = true;
					break;
				case 'Exists':
					this.zakazkaExistsDialog();
					break;
				case 'TooManyExists':
					this.tooManyExists();
					break;
				default:
					break;
			}
		},
	},
	methods: {
		async loadData() {
			await this.fetchTableSchemas();
			if (this.isCreateMode) {
				// pokud jsem na Create modu ze zpracuj Planovane zapujcky, vola API request s CreateFromPlanpujcpa, jinak default
				if (this.$route.params.planpujcpaId) {
					await this.createFromPlanovanaPujcka(this.$route.params.planpujcpaId as any);
					if (this.VozidlopaId) {
						this.VyrobekvozOzn = (await apiProvider.getVozidloPujcovna(this.VozidlopaId)).data.VyrobekvozOzn;
					}
				} else {
					await this.default();
				}
			} else {
				await this.entity();
				await this.fetchTableData();
				if (this.VozidlopaId) {
					this.VyrobekvozOzn = (await apiProvider.getVozidloPujcovna(this.VozidlopaId)).data.VyrobekvozOzn;
				}
			}
		},
		async createZakazkaClick() {
			this.startLoadingV2();
			const resp = await this.save(false);
			const { UserMessageList } = resp.data;
			if (UserMessageList && UserMessageList.length > 0) {
				this.endLoadingV2();
				return;
			}

			const id = (await apiProvider.getZakazkaId({ PujcovnapaId: this.PujcovnapaId })).data;

			this.endLoadingV2();

			if (id !== -1 && !(resp instanceof Error)) {
				this.showConfirm({
					message: `${this.LocalizeChyboveHlasky('ZakazkapaJinaZak')} ${this.ZakazkaDruh} ${this.ZakazkaNr} ${this.LocalizeChyboveHlasky('OtevritZakazku')}`,
					options: {
						cancelButtonText: this.Localize('cmdStorno'),
						confirmButtonText: this.Localize('Ok'),
						callback: async (action) => {
							if (action === 'confirm') {
								this.openZakazka(id);
							}
						},
					},
				});
			}
			if (id === -1 && !(resp instanceof Error)) {
				this.startLoadingV2();
				const zakazkaId = Number(await this.createZakazka());
				openEdit(ZAKAZKA_ZAPUJCKA, PageMode.CREATE, {
					props: true,
					filter: { ZakazkaId: zakazkaId, PujcovnapaId: this.PujcovnapaId },
					ZakaznikId: this.ZakaznikId,
					PujcovnapaNr: this.PujcovnapaNr,
					PujcvnaCreateZakazka: true,
				});
			}
			this.endLoadingV2();
		},
		existPlanovanaPujcka() {
			let message = this.LocalizeChyboveHlasky('PlanVozidloPA_Dms3');
			message = message
				.replace('{0}', this.PujcNr!)
				.replace('{1}', formatDateTime(this.VydejkaDat)!)
				.replace('{2}', formatDateTime(this.VraceniDat)!);
			showAlert({ message });
		},
		openDoklad(event: any) {
			openEdit(Doklad.name, PageMode.VIEW, { id: event.data.ID });
		},
		openZakazka(id = 0) {
			if (id === 0) {
				openEdit(ZakazkaName, PageMode.EDIT, { id: this.RozsireniZakazkaId! });
			} else {
				openEdit(ZakazkaName, PageMode.EDIT, { id });
			}
		},
		async saveClick() {
			// Pokud nebyla vytisknuta smlouva a uzivatel se pokusi ulozit, je treba vytisknout smlouvu
			if (this.RozsirProtokol) {
				const questionResult = await this.showConfirm({
					message: await this.LocalizeTextLong('NONajZmlPrint'),
					title: await this.LocalizeChyboveHlasky('questionTitle'),
					options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				if (questionResult) {
					this.save(false);
				}
			} else {
				await this.save(true);
			}
		},
		async rozsirProtokol(answer: boolean) {
			// dotaz na api pro RozsireniProtokolu, vraci prava, rozsireny stav zapujcky a stav 'RozsirProtokol'
			await this.rozsireniProtokolu(answer);
			this.showRozsirDialog = false;
			if (answer && this.zapujckaStav.isOtevrena) {
				EventBus.$emit('DisableAll', false);
			}
			if (!answer && !this.RozsirProtokol) {
				// clear poli po rozsireni stavu zapujcky
				await this.zapujckaRozsirProtokol();
				this.printAfterSave = false;
				await this.save(false);
			}
			this.rozsirDialogReset();
		},
		rozsirDialogReset() {
			this.showRozsirDialog = false;
			this.zapujckaCheckResultReset();
		},
		localizeZakazkaDruh() {
			return this.LocalizePopisostatni((ZAKAZKA_DRUH_LOCALIZED as Record<string, string>)[this.RozsireniZakazkaDruh!]);
		},
		async zakazkaExistsDialog() {
			// Pokud existuje zakazka pro zapujcku, neni mozne rozsirit, zepta se zda zakazku otevrit
			const msg = `${this.LocalizeChyboveHlasky('ZakazkapaJinaZak')} ${this.localizeZakazkaDruh()}
				${this.RozsireniZakazkaNr}. ${this.LocalizeChyboveHlasky('OtevritZakazku')} ?`;
			const questionResult = await this.showConfirm({
				message: msg,
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
			if (questionResult) {
				this.openZakazka();
			}
			this.rozsirDialogReset();
		},
		tooManyExists() {
			// Vice zakazek na zapujcku, neni mozne rozsirit, jen je vypise v dialogu
			const message = `${this.LocalizeChyboveHlasky('VelaZakNaPuj')}: ${this.RozsireniZakazkaNrs!.join(', ')}.`;
			showAlert({ message });
			this.rozsirDialogReset();
		},
		async tiskSouhlasuSkodaConnect() {
			const saveResult = await this.save(false);
			if (saveResult instanceof Error) return;

			const { tiskDialog } = this;
			tiskDialog.zakaznikId = this.ZakaznikId;
			tiskDialog.filter = {
				Id: this.PujcovnapaId,
				PrintDialog: true,
				ReportType: 'pdf',
			};
			tiskDialog.fetchPdfProvider = async (filter: {}) => {
				try {
					const report = await apiProvider.getInforSouhlasConnReport(filter);
					await this.printed();
					return report;
				} catch (err) {
					this.logError(err as Error);
					throw err;
				}
			};
			tiskDialog.visible = true;
		},
		async tiskNajemniSmlouvaTyp(typ: NAJEMNI_SMLOUVA_TYP) {
			const { tiskDialog } = this;
			tiskDialog.zakaznikId = this.ZakaznikId;
			tiskDialog.filter = {
				PujcovnapaId: this.PujcovnapaId,
				ReportType: 'pdf',
				TypTisku: typ,
			};
			tiskDialog.fetchPdfProvider = async (filter: {}) => {
				try {
					const report = await apiProvider.getNajemniSmlouvaReport(filter);
					await this.printed();
					return report;
				} catch (err) {
					this.logError(err as Error);
					throw err;
				}
			};
			tiskDialog.visible = true;
		},
		async tiskNajemniSmlouva() {
			const saveResult = await this.changeToEdit();
			if (saveResult instanceof Error) return;
			await this.tiskNajemniSmlouvaTyp(NAJEMNI_SMLOUVA_TYP.ORIGINAL);
		},
		async tiskKopiePredani() {
			await this.tiskNajemniSmlouvaTyp(NAJEMNI_SMLOUVA_TYP.KOPIE_PREDANI);
		},
		async tiskKopiePrevzeti() {
			await this.tiskNajemniSmlouvaTyp(NAJEMNI_SMLOUVA_TYP.KOPIE_PREVZETI);
		},
		async printed() {
			await this.entity();
			this.RozsirProtokol = false;
		},
		createSkodaNaVozidle() {
			openEdit(HlaseniOSkode.name, PageMode.CREATE, { filter: this.skodyNaPujccePolozkyFilter });
		},
		async openSkodaHlaseni() {
			const resp = this.isCreateMode ? await this.changeToEdit() : await this.save(false);
			if (resp instanceof Error) return;
			await openList(HlaseniOSkode.name, { filter: { PujcovnapaId: this.PujcovnapaId, ...this.skodyNaPujccePolozkyFilter } });
		},
		prepocetKm() {
			const kmVolneDen = Math.floor((this.VolneKmDen || 0) * (this.DenPlaceno || 0));
			if (!_.isNil(this.KmStavOd) && !_.isNil(this.KmStavDo)) {
				this.KmPlaceno = this.KmStavDo - this.KmStavOd - (this.KmVolne || 0) - kmVolneDen;
				if (this.KmPlaceno < 0) {
					this.KmPlaceno = 0;
				}
			}
		},
		zaokrouhliInterval(datumOd: Date, datumDo: Date) {
			const utcOd = Date.UTC(datumOd.getFullYear(), datumOd.getMonth(), datumOd.getDate(), datumOd.getHours(), datumOd.getMinutes());
			// datumDo -1 minuta => exkluzivni interval
			const utcDo = Date.UTC(datumDo.getFullYear(), datumDo.getMonth(), datumDo.getDate(), datumDo.getHours(), datumDo.getMinutes() - 1);
			return (Math.floor(utcDo * INTERVAL / MILISEKUNDY_DEN) - Math.floor(utcOd * INTERVAL / MILISEKUNDY_DEN) + 1) / INTERVAL;
		},
		prepocetDnu() {
			if (_.isNil(this.FakturaceDatOd) || _.isNil(this.PujckapredDatDo)) {
				return;
			}

			const datumOd = this.FakturaceDatOd;
			const datumDo = this.PujckaDatDo || this.PujckapredDatDo;
			const datumFak = this.FaktpristDat;

			if (datumDo > datumOd && !this.DlouhodobPrp) {
				this.DenPlaceno = this.zaokrouhliInterval(datumOd, datumDo);
			} else if (datumFak && datumFak > datumOd && this.DlouhodobPrp) {
				this.DenPlaceno = this.zaokrouhliInterval(datumOd, datumFak);
				this.FaktpristDat = this.PujckaDatDo;
			} else {
				this.DenPlaceno = 0;
			}
		},
	},
});
